import { Action } from '@ngrx/store';
import { AppState } from '..';

export enum FormDataActionTypes {
    FetchFormData = '[APS] Fetch Data',
    LoadFormData = '[APS] Load Data',
    SaveData = '[APS] Save Data',
    LoadFormDataWithSync = '[APS] Fetch Data with Sync',
    LoadFormDataWithButtonSync = '[APS] Sync Data with button',
}

export class FetchFormData implements Action {
  readonly type = FormDataActionTypes.FetchFormData;
  constructor(public id: string, public agentId: number) { }
}

export class LoadFormData implements Action {
  readonly type = FormDataActionTypes.LoadFormData;
  constructor(public payload: any) { }
}

export class SaveData implements Action {
  readonly type = FormDataActionTypes.SaveData;
  constructor(public apsReportLoadId: number, public apsData: any) { }
}

export class LoadFormDataWithSync implements Action {
  readonly type = FormDataActionTypes.LoadFormDataWithSync;
  constructor(public payload: any) { }
}

export class LoadFormDataWithButtonSync implements Action {
  readonly type = FormDataActionTypes.LoadFormDataWithButtonSync;
  constructor(public payload: any) { }
}


export type FormDataAction =
  | FetchFormData
  | LoadFormData
  | SaveData
  | LoadFormDataWithSync
  | LoadFormDataWithButtonSync
;
